<template>
  <div class="main-wrapper">
    <h1>Pedido {{ orderId }}</h1>
    <div class="flex" v-if="order">
      <section class="box detail-order">
        <div class="panel-header">
            <div class="title pull-left">Detalhamento</div>
        </div>
        <div class="content-body">
          <b-container fluid>

              <b-row class="mb-3">
                <b-col cols="3">
                  <b-img fluid :src="order.event.image" :alt="order.event.name"></b-img>
                </b-col>
                <b-col cols="9">
                  <table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold">Evento</td>
                        <td>{{ order.event.name }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Data</td>
                        <td>{{ order.event.date | date }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Local</td>
                        <td>{{ order.event.location }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="7">
                  <table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold">Status Pedido</td>
                        <td>{{ order.status | orderStatus }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Status Entrega</td>
                        <td>
                          <span style="color:#27ae60;" v-if="order.delivery_status == 'delivered'"><icon scale="0.9" name="check"></icon></span>
                          <span style="color:#e74c3c;" v-if="order.delivery_status == 'warning'"><icon scale="0.9" name="exclamation-triangle"></icon></span>
                          <span v-if="order.delivery_status == null">-</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Comprador</td>
                        <td>{{ order.email }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Forma pag.</td>
                        <td>{{ order.payment_method | paymentMethod }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Cobrança</td>
                        <td><a :href="order.detail_charge_id" :title="order.charge_id" target="_blank">{{ order.charge_id }}</a></td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Total ingressos</td>
                        <td>{{ order.amount }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Criado em</td>
                        <td>{{ order.created_at | date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
                <b-col cols="5">
                  <table>
                    <tbody>
                      <tr>
                        <td class="font-weight-bold">Ingresso</td>
                        <td>+ {{ order.value | currency }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Tarifa</td>
                        <td>+ {{ order.rate | currency }}</td>
                      </tr>
                      <tr>
                        <td class="font-weight-bold">Total</td>
                        <td class="font-weight-bold">= {{ order.total | currency }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <h1 class="sub1">Ingressos</h1>

                  <table class="mb-4">
                    <thead>
                      <tr>
                        <th>Lote</th>
                        <th>Valor</th>
                        <th>Nro. Ingresso</th>
                        <th>Status Entrega</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in order.items" :key="item.id">
                        <td>{{ item.batch_name }}</td>
                        <td>{{ item.value | currency }}</td>
                        <td>{{ item.ticket_number }}</td>
                        <td>
                          <span style="color:#27ae60;" v-if="item.delivery_status == 'delivered'"><icon scale="0.9" name="check"></icon></span>
                          <span style="color:#e74c3c;" v-if="item.delivery_status == 'warning'"><icon scale="0.9" name="exclamation-triangle"></icon></span>
                          <span style="color:#969630;" v-if="item.delivery_status == 'queued'"><icon scale="0.9" name="exclamation-triangle"></icon> Agendado</span>
                          <span v-if="item.delivery_status == null">-</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </b-col>
              </b-row>

              <b-row>
                <b-col>
                  <h1 class="sub1">Histórico <span @click="reload">Atualizar</span></h1>
                  <table class="mb-4">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Data</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="history in order.histories" :key="history.id">
                        <td>{{ history.description }}</td>
                        <td>{{ history.created_at | date }}</td>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>

            </b-container>
        </div>
      </section>

      <section class="box order-resend">
        <div class="panel-header">
            <div class="title pull-left">Reenviar ingresso?</div>
        </div>
        <div class="content-body">
          <b-alert :variant="feedback.type" dismissible :show="feedback.show" fade
            @dismissed="feedback.show=false">
              {{ feedback.data }}
          </b-alert>
          <b-form @submit.prevent="resend">
            <b-form-group
              label="E-mail:"
              description="Exemplo: novo-email@gmail.com">
              <b-form-input v-model="form.email" type="email" required />
            </b-form-group>
            <b-button type="submit" variant="primary" class="float-right mb-4">Solicitar reenvio</b-button>
          </b-form>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Order',
  data () {
    return {
      orderId: parseInt(this.$route.params.id),
      order: '',
      form: {
        email: ''
      },
      feedback: {
        data: '',
        type: '',
        show: false
      }
    }
  },
  mounted () {
    this.detailOrder(this.orderId)
  },
  methods: {
    detailOrder (orderId) {
      let url = process.env.VUE_APP_URL_APP + '/b/admin/orders/' + orderId
      return this.$http.get(url).then(res => {
        this.order = res.body
      }, err => {
        console.log(err)
      })
    },
    reload () {
      this.detailOrder(this.orderId)
    },
    resend () {
      if (this.order.status !== 'generated') {
        this.feedback.data = 'Os ingressos do pedido ainda não foram gerados, por isto não é possível solicitar o reenvio. Confira o histórico.'
        this.feedback.type = 'danger'
        this.feedback.show = true
        return
      }
      if (this.form.email === '') {
        this.feedback.data = 'Informe o e-mail'
        this.feedback.type = 'danger'
        this.feedback.show = true
        return
      }
      const url = process.env.VUE_APP_URL_APP + '/b/admin/orders/' + this.orderId + '/resend'
      this.$http.put(url, this.form).then(res => {
        this.detailOrder(this.orderId)
        this.form.email = ''
        this.feedback.data = 'Solicitado com sucesso!'
        this.feedback.type = 'success'
        this.feedback.show = true
      }, err => {
        this.feedback.data = err.body.message
        this.feedback.type = 'danger'
        this.feedback.show = true
        console.log(err)
      })
    }
  },
  filters: {
    paymentMethod (value) {
      if (value === 'billet') {
        return 'Boleto'
      }
      if (value === 'card') {
        return 'Cartão'
      }
      if (value === 'pix') {
        return 'Pix'
      }
      return 'Desconhecido'
    }
  }
}
</script>

<style lang="scss" scoped>
.main div.main-content .main-wrapper {
  .detail-order {
    width: 65%;
  }
  .order-resend {
    width: 35%;
  }
  .sub1 {
    font-size: 19px;
    span {
      font-size: 11px;
      cursor: pointer;
    }
  }
}
</style>
